// extracted by mini-css-extract-plugin
module.exports = {"list":"CommentsContentLoader_list__1RXXx","message":"CommentsContentLoader_message__2gu9u"};